export const NUVELOR_PUBLIC_ORIGIN = "https://nuvelor.gg";
export const NUVELOR_MARKET_ORIGIN = "https://market.nuvelor.gg/";
export const NUVELOR_APP_URL = "https://t.me/NuvelorBot";

export const NUVELOR_SOCIAL_LINKS = Object.freeze({
  telegram: "https://t.me/Nuvelor",
  community: "https://t.me/Nuvelor_Chat",
  x: "https://x.com/nuvelor",
  instagram: "https://instagram.com/nuvelor",
});

export const NUVELOR_PUBLIC_SECTIONS = Object.freeze([
  "game",
  "nfts",
  "marketplace",
  "economy",
  "guides",
  "roadmap",
  "about",
]);

export function nuvelorPublicPath(lang, section = "") {
  const safeLang = ["en", "uk", "de", "ru"].includes(lang) ? lang : "en";
  return `/${safeLang}/${section ? `${section}/` : ""}`;
}

export function nuvelorPublicUrl(lang, section = "") {
  return `${NUVELOR_PUBLIC_ORIGIN}${nuvelorPublicPath(lang, section)}`;
}
